export interface PageGroupData {
  id: number
  client_id: number
  name: string
  enabled: boolean
  start_date: string | null
  end_date: string | null
  page_description: string
  campaign_id: number | null
  analytics_html: string
}

export interface SwitchoverPair {
  switchoverDate: string
  name: string
  fromPage: PageGroupData
  toPage: PageGroupData | null
}

/** キャンペーン以外の通常ページかどうか判定 */
export function isRegularPage(pg: PageGroupData): boolean {
  return !pg.campaign_id && pg.name !== 'campaign'
}

/**
 * Find all upcoming switchover pairs.
 * Groups enabled pages by name, sorts by start_date, and pairs each page
 * with the next page in the sequence (the successor).
 */
export function findSwitchoverPairs(pageGroups: PageGroupData[]): SwitchoverPair[] {
  const now = new Date()
  const pages = pageGroups.filter((pg) => isRegularPage(pg) && pg.enabled)

  // Group by name
  const byName: Record<string, PageGroupData[]> = {}
  for (const pg of pages) {
    if (!pg.start_date || !pg.end_date) continue
    if (!byName[pg.name]) byName[pg.name] = []
    byName[pg.name].push(pg)
  }

  const pairs: SwitchoverPair[] = []

  for (const name of Object.keys(byName)) {
    const sorted = [...byName[name]].sort(
      (a, b) => new Date(a.start_date!).getTime() - new Date(b.start_date!).getTime()
    )

    for (let i = 0; i < sorted.length; i++) {
      const fromPage = sorted[i]
      if (new Date(fromPage.end_date!) <= now) continue

      const nextPage = sorted[i + 1] || null

      // ギャップがあるかチェック（end_dateとstart_dateの間が2分以内なら連続と判定）
      // 引き継ぎ先のend_dateが引き継ぎ元のend_dateより後でなければ引き継ぎ対象外
      let toPage: PageGroupData | null = null
      if (nextPage) {
        const endDate = new Date(fromPage.end_date!)
        const startDate = new Date(nextPage.start_date!)
        const nextEndDate = new Date(nextPage.end_date!)
        const gapMs = startDate.getTime() - endDate.getTime()
        if (gapMs <= 2 * 60 * 1000 && nextEndDate.getTime() > endDate.getTime()) {
          toPage = nextPage
        }
      }

      pairs.push({
        switchoverDate: fromPage.end_date!,
        name,
        fromPage,
        toPage,
      })
    }
  }

  pairs.sort((a, b) => a.fromPage.id - b.fromPage.id)

  return pairs
}
